import type { ReactNode } from 'react';

export const symbol_nest_sunblock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-710v-60q0-13 8.5-21.5T110-800q13 0 21.5 8.5T140-770v60q0 13-8.5 21.5T110-680q-13 0-21.5-8.5T80-710Zm0 520v-60q0-13 8.5-21.5T110-280q13 0 21.5 8.5T140-250v60q0 13-8.5 21.5T110-160q-13 0-21.5-8.5T80-190Zm267-474-43 43q-9 9-21 8.5t-21-9.5q-9-9-9-21.5t9-21.5l42-42q9-9 21.5-9t21.5 9q9 9 9 21.5t-9 21.5Zm-43 410-43-42q-9-9-8.5-21t9.5-21q9-9 21.5-9t21.5 9l42 42q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9Zm286-256-70-93q-8-10-6-22t12-20q10-8 22-6t20 12l106 141q11 15 3 31.5T650-450H350q-13 0-21.5-8.5T320-480q0-13 8.5-21.5T350-510h240Zm240 310q-20 0-35-15t-15-35v-460q0-21 15-35.5t35-14.5q21 0 35.5 14.5T880-710v460q0 20-14.5 35T830-200ZM80-330v-60q38 0 64-26.5t26-63.5q0-38-26-64t-64-26v-60q63 0 106.5 43.5T230-480q0 62-43.5 106T80-330Z"
		/>
	</svg>
);
